import ajax from '../util/ajax';

/*
 * =====================================================
 *                        样板间--公路学会
 * =====================================================
 */
/**
 * 党建设
 * @method getParty
 * @public
 */
export function getParty() {
    return ajax({
        url: '/scimallH5/Ybjhighway/party'
    });
}
/**
 * 智库
 * @method getIdea
 * @public
 */
export function getIdea() {
    return ajax({
        url: '/scimallH5/Ybjhighway/idea'
    });
}
/**
 * 交通运输大会举办情况
 * @method getTrafficMeet
 * @public
 */
export function getTrafficMeet() {
    return ajax({
        url: '/scimallH5/Ybjhighway/trafficMeet'
    });
}
/**
 * “一带一路”国际交通联盟发展情况
 * @method getTrafficLeague
 * @public
 */
export function getTrafficLeague() {
    return ajax({
        url: '/scimallH5/Ybjhighway/trafficLeague'
    });
}
/**
 * 学术
 * @method getScholarism
 * @public
 */
export function getScholarism() {
    return ajax({
        url: '/scimallH5/Ybjhighway/scholarism'
    });
}
/**
 * 科普-学会举办科普活动情况
 * @method getDomain
 * @public
 */
export function getKepu() {
    return ajax({
        url: '/scimallH5/Ybjhighway/kepu'
    });
}

/*
 * =====================================================
 *                        样板间--化学会
 * =====================================================
 */
/**
 * 学术研究动态
 * @method getTrends
 * @public
 */
export function getTrends() {
    return ajax({
        url: '/scimallH5/YbjChemistry/trends'
    });
}
/**
 * 党建设
 * @method getHparty
 * @public
 */
export function getHparty() {
    return ajax({
        url: '/scimallH5/YbjChemistry/party'
    });
}
/**
 * 会员地域分布
 * @method getVipDistribute
 * @public
 */
export function getVipDistribute() {
    return ajax({
        url: '/scimallH5/YbjChemistry/vipDistribute'
    });
}
/**
 * 智库
 * @method getHidea
 * @public
 */
export function getHidea() {
    return ajax({
        url: '/scimallH5/YbjChemistry/idea'
    });
}
/**
 * 学术-学会举办的各类学术活动情况
 * @method getHtrafficMeet
 * @public
 */
export function getHtrafficMeet() {
    return ajax({
        url: '/scimallH5/YbjChemistry/trafficMeet'
    });
}
/**
 * 科普-学会举办科普活动情况
 * @method getHkepu
 * @public
 */
export function getHkepu() {
    return ajax({
        url: '/scimallH5/YbjChemistry/kepu'
    });
}

/*
 * =====================================================
 *                        样板间--机械学会
 * =====================================================
 */
/**
 * 党建
 * @method getJparty
 * @public
 */
export function getJparty() {
    return ajax({
        url: '/scimallH5/ybjmachinery/party'
    });
}
/**
 * 智库
 * @method getJidea
 * @public
 */
export function getJidea() {
    return ajax({
        url: '/scimallH5/ybjmachinery/idea'
    });
}
/**
 * 制造业专业知识服务系统访问量
 * @method getServerView
 * @public
 */
export function getServerView() {
    return ajax({
        url: '/scimallH5/ybjmachinery/serverView'
    });
}
/**
 * 在线教育及认证
 * @method getOnlineEdu
 * @public
 */
export function getOnlineEdu() {
    return ajax({
        url: '/scimallH5/ybjmachinery/onlineEdu'
    });
}
/**
 * 学术
 * @method getJScholarism
 * @public
 */
export function getJScholarism() {
    return ajax({
        url: '/scimallH5/ybjmachinery/scholarism'
    });
}
/**
 * 科普-学会举办科普活动情况
 * @method getJkepu
 * @public
 */
export function getJkepu() {
    return ajax({
        url: '/scimallH5/ybjmachinery/kepu'
    });
}
/*
 * =====================================================
 *                        样板间--汽车工程学会数据接口
 * =====================================================
 */
/**
 * 汽车大赛
 * @method getCarRace
 * @public
 */
export function getCarRace() {
    return ajax({
        url: '/scimallH5/YbjAutomotive/carRace'
    });
}
/**
 * 科普-学会举办科普活动情况
 * @method getCkepu
 * @public
 */
export function getCkepu() {
    return ajax({
        url: '/scimallH5/YbjAutomotive/kepu'
    });
}
/**
 * 智库
 * @method getCidea
 * @public
 */
export function getCidea() {
    return ajax({
        url: '/scimallH5/YbjAutomotive/idea'
    });
}
/**
 * 党建
 * @method getCparty
 * @public
 */
export function getCparty() {
    return ajax({
        url: '/scimallH5/YbjAutomotive/party'
    });
}
/**
 * 科技奖励
 * @method getScienceAward
 * @public
 */
export function getScienceAward() {
    return ajax({
        url: '/scimallH5/YbjAutomotive/scienceAward'
    });
}
/**
 * 学术-学会举办的各类学术活动情况
 * @method getCtrends
 * @public
 */
export function getCtrends() {
    return ajax({
        url: '/scimallH5/YbjAutomotive/trends'
    });
}

/**
 * 会员数量
 * @method getVipCount
 * @public
 */
export function getVipCount() {
    return ajax({
        url: '/scimallH5/YbjAutomotive/vipCount'
    });
}

/*
 * =====================================================
 *                        样板间--电机学会数据接口
 * =====================================================
 */
/**
 * 党建
 * @method getDparty
 * @public
 */
export function getDparty() {
    return ajax({
        url: '/scimallH5/Ybjmotor/party'
    });
}
/**
 * 智库
 * @method getDidea
 * @public
 */
export function getDidea() {
    return ajax({
        url: '/scimallH5/Ybjmotor/idea'
    });
}
/**
 * 数字图书馆
 * @method getDlibrary
 * @public
 */
export function getDlibrary() {
    return ajax({
        url: '/scimallH5/Ybjmotor/library'
    });
}
/**
 * 学术
 * @method getDscholarism
 * @public
 */
export function getDscholarism() {
    return ajax({
        url: '/scimallH5/Ybjmotor/scholarism'
    });
}
/**
 * 科普-学会举办科普活动情况
 * @method getDkepu
 * @public
 */
export function getDkepu() {
    return ajax({
        url: '/scimallH5/Ybjmotor/kepu'
    });
}